var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEligibleCashback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #2663eb;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.2,57.1c-3.7,1.7-7.6,2.6-11.6,2.6s-6.2-.5-9.2-1.6c-6.9-2.4-12.3-7.4-15.5-14-1.7-3.5-2.6-7.5-2.6-11.4-.1-4.7,1-9.4,3.1-13.6l3.3,2.6c.5.4,1,.6,1.6.6s.8,0,1.1-.3c.9-.4,1.5-1.4,1.5-2.4v-10.7c0-.8-.4-1.5-1-2-.5-.4-1.1-.6-1.7-.6s-.3,0-.5,0l-10.7,2.1c-1,.2-1.8,1-2,2-.2,1,.1,2,.9,2.7l3.2,2.6C1.3,21-.1,26.9,0,32.8c0,4.7,1.1,9.3,3.1,13.6,3.7,7.8,10.3,13.8,18.4,16.7,3.6,1.3,7.2,1.9,11,1.9s9.5-1.1,13.9-3.1l.4-.2-2.2-4.8-.4.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.5,49c2.9-5,4.5-10.7,4.5-16.5,0-17.9-14.6-32.5-32.5-32.5h-.3c-3.9,0-7.7.8-11.3,2.1l-.5.2,1.9,4.9.5-.2c3-1.2,6.2-1.8,9.4-1.8h.3c15,0,27.2,12.2,27.2,27.2,0,4.6-1.2,9.1-3.4,13.1l-3-2.4c-.5-.4-1-.6-1.6-.6s-.8,0-1.1.3c-.9.4-1.5,1.4-1.5,2.4v10.7c0,.8.4,1.5,1,2,.5.4,1.1.6,1.7.6s.3,0,.5,0l10.7-2.1c1-.2,1.8-1,2-2,.2-1-.1-2-.9-2.7l-3.5-2.8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.8,34.7c-2.2,0-3.3-.2-4.7-.5h-.6c0-.1,0,4.2,0,4.2l8.7,11.7h6.4l-8.4-11c5.1-.2,8.5-3.4,9.1-8.4h4.9v-4.6h-4.7c0-1.6-.2-3-.4-4.3h5.2v-4.6h-20.7v4.6h10.3c.4,1.2.5,2.6.5,4.3h-10.9v4.6h10.7c-.4,2.7-2.1,4-5.4,4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEligibleCashback);
export default __webpack_public_path__ + "static/media/EligibleCashback.4f366f9c3e75e556fabb1d22382cb4c5.svg";
export { ForwardRef as ReactComponent };